import { createContext } from 'use-context-selector';
import envConfig from './../environments/environmentLoader';
export const ConfigContext = createContext({ config: envConfig() });
